export const PLAYER_CONNECTION_LOST = 'vl:player-connection-lost';
export const isPlayerLobbyPath = path => /^\/(?:[^/]+\/)?app(?:\/|$)/.test(path || '');
export const isTransportFailure = error => !error?.response
  && !['ERR_CANCELED', 'SESSION_CHANGED'].includes(error?.code)
  && Boolean(error?.request || ['ERR_NETWORK', 'ECONNABORTED', 'ETIMEDOUT'].includes(error?.code));

export function reportPlayerConnectionFailure(error) {
  if (typeof window === 'undefined' || !isPlayerLobbyPath(window.location.pathname)
    || error?.config?.ignorePlayerConnection || String(error?.config?.url || '').includes('/api/client-errors')
    || !isTransportFailure(error)) return;
  window.dispatchEvent(new Event(PLAYER_CONNECTION_LOST));
}
